import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import axios from "axios";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "./ui/sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Layout = () => {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [location.pathname]);

    useEffect(() => {
        // Anonymous, self-hosted page-view ping — no cookies, no third party.
        // Skip admin pages and skip the site owner's visits entirely.
        if (location.pathname.startsWith("/admin")) {
            try { localStorage.setItem("ds_owner", "1"); } catch (_) {}
            return;
        }
        try { if (localStorage.getItem("ds_owner")) return; } catch (_) {}
        axios.post(`${API}/track/pageview`, { path: location.pathname }).catch(() => {});
    }, [location.pathname]);

    return (
        <div className="App relative">
            <Header />
            <main className="pt-16 md:pt-20" data-testid="main-content">
                <Outlet />
            </main>
            <Footer />
            <Toaster
                position="top-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#0B0C15",
                        color: "#FFFFFF",
                        border: "1px solid rgba(255,255,255,0.1)",
                        borderRadius: 0,
                    },
                }}
            />
        </div>
    );
};

export default Layout;
